import styled from "styled-components";

export const User = styled.div`
    .userName{
        h2{
            font-size: 24px;
            font-weight: 500;
            color: #87868F;
            margin:25px 0 0 199px;
            font-family: 'Quicksand', sans-serif;
        }
    }

    .avatarRound {
        border-radius: 50%;
        object-fit: cover;
    }


    .viewUser{
        display: flex;
        width: 100%;
        flex-direction: row;
    }

    .MuiInput-underline-15:before {
        border-bottom: none;
    }

    .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
        border-bottom: none;
    }

    /** changePhoto**/
    .changePhoto{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 40px 60px 0 25px;

        h2{
            color: #403F4C;
            font-size: 14px;
            margin: 0 0 10px 0;
        }

        .photo{
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .fileUpload {
            position: relative;
            overflow: hidden;
            margin: 10px;
            border-radius: 26px;
            border: 1px solid #787780;
            width: 93px;
            height: 20px;
            text-align: center;
            font-size: 11px;
            font-weight: 500;
            opacity: 0.7;
            display: flex;
            align-items: center;
            justify-content: center;

            span{
                align-items: center;
                display: flex;
            }

            input.upload {
                position: absolute;
                top: 0;
                right: 0;
                margin: 0;
                padding: 0;
                font-size: 20px;
                cursor: pointer;
                opacity: 0;
                filter: alpha(opacity=0);
            }
        }

        span{
            img{
                padding: 0 5px 0 0;
            }
        }
    }

    /** Form **/
    .formulario{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        margin: 40px 100px 0 0;
        width: 100%;

        /* .react-inputs-validation__textbox__container___3KXOM{
            width: 45%;
            margin-right: 5px;
        } */

        .addEmail{
            display: flex;

            input{
                width: 460px;
            }
        }

        .label{
            margin: 0 0 -15px 0;
        }


        label{
            color: #403F4C;
            font-size: 14px;
            font-weight: bold;
        }

        span{
            color: #87868F;
            font-size: 10px;
            margin-left: 5px;
        }


        select{
            width: 220px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
            color: #403F4C;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
        }


        .profile{
            display: flex;
            justify-content: flex-start;
            margin-bottom: 25px;
            /* width: 100%; */
            /* max-width: 59%; */

            /* select{
                width: 220px;
                &:last-child{
                    display: none;
                }
            } */

            /* .role{
                width: 100%;
                max-width: 34%;
            } */

            .active{
                background-color: #00D36A;
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-left: 240px;
                font-family: 'Quicksand', sans-serif;
            }

            .inactive{
                background-color: red;
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-left: 240px;
            }
        }


        input{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            padding-left: 10px;
            margin-bottom: 15px;
            font-size: 14px;
            font-family: 'Quicksand', sans-serif;
        }

        .genderBox{
            margin-bottom: 25px;
        }


        .addInput{
            width: 110px;
            height: 32px;
            border-radius: 26px;
            margin-left: 20px;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            font-family: 'Work Sans', sans-serif;
            font-size: 14px;
            cursor: pointer;
        }

        .inputs{
            display: flex;

            .lineInputs{
                margin-right: 23px;

                button{
                    margin: 21px 0 0 0
                }

                .gender{
                    width: 243px;
                }


                .MuiInput-input-14 {
                    width: 215px;
                    border: none;
                    height: 19px;
                    margin: 0;
                }

                .MuiFormControl-root-30 {
                    border: 1px solid;
                    border-radius: 26px;
                    border: 1px solid #B2B2B7;
                }

                input{
                    width: 220px;
                }

                select.userPhoneTypeId{
                    width: 300px;
                }

            }

            p{
                font-size: 11px;
                color: #87868F;
                margin-top: 22px;
            }
        }

        button.delete{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #FF5666;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 20px;
        }

        button.deleteLast{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #FF5666;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 0;
            font-family: 'Quicksand', sans-serif;
        }

        .removephone{
            margin: 0 0 0 -25px;
        }


    }

    .button{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 15px;

        button.save{
          padding: 10px 20px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 24px 0 30px 0;
            font-family: 'Work Sans', sans-serif;
        }

        button.back{
            width: 72px;
            height: 28px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #787780;
            color: #787780;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 30px 15px 30px 0px;

            .fa{
                margin-right: 3px;
            }
        }
    }

    input.jsx-4179805763  {
        width: 226px !important;
        height: 32px;
        border-radius: 26px;
        border: 1px solid #B2B2B7;
        padding-left: 10px;
        margin-bottom: 0;
        margin-top: 0;
    }

    button.jsx-4179805763  {
        margin: 0 0 1px 0 !important;
    }

    input[type='number'] {
        -moz-appearance:textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

`;

export const FilterUser = styled(User)`
    h2{
        font-size: 20px;
        font-weight: 400;
        color: #87868F;
        font-family: 'Quicksand', sans-serif;
        .fa{
            margin: 0 5px 0 0;
        }
    }

    .inativo{
        color: #FF5666;
        font-weight: bold;
    }


    .formulario{
        flex-direction: row;
        margin: 10px 0 0 0;

        .lineInput{
            display: flex;
            flex-direction: column;
            margin: 0 16px 0 0;
            width: 100%;
        }

        input {
            width: auto;

        }

        select{
            width: auto;
        }
    }

    .button{
        display: flex;
        justify-content: flex-end;
        width: 100%;

        button{
            width: 149px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 0 0 20px 0;
        }
    }

    .buttons{
        display: flex;
        justify-content: flex-end;
        font-family: 'Quicksand', sans-serif;

        .Users-wrapper-2 {
            position: relative;
            width: 81px;
            height: 28px;
        }
        button{
            width: 84px;
            height: 22px;
            border-radius: 26px;
            background: #fff;
            border: 1px solid #B2B2B7;
            color: #B2B2B7;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 14px 0 0 0;
            margin-right: 10px;
            font-family: 'Quicksand', sans-serif;

            &:last-child{
                width: 84px;
                height: 22px;
                border-radius: 26px;
                background: #004FFF;
                border: 1px solid #004FFF;
                color: #fff;
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin: 10px 18px 0 0;
            }


            &:disabled,
                button[disabled]{
                width: 58px;
            }

        }

        button.save {
            padding: 10px 20px;
            height: 22px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 10px 18px 0 0;
            font-family: 'Work Sans', sans-serif;
        }


    }

    .buttonsSelect{
        display: flex;
        flex-direction: row;
        align-content: flex-start;
        font-family: 'Quicksand', sans-serif;
        align-items: flex-start;

        button {
            width: 84px;
            height: 22px;
            border-radius: 26px;
            background: #fff;
            border: 1px solid #B2B2B7;
            color: #B2B2B7;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin-right: 10px;
            font-family: 'Quicksand', sans-serif;
        }

        button.active {
            width: 84px;
            height: 22px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
        }

    }


    .teacherListBox{
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 5px;
        padding: 15px;
        box-shadow: 1px 1px 4px 1px #DADADA;
        display: flex;
        align-items: flex-start;
        flex-direction: row;
        margin-top: 25px;

        h3 {
            margin-right: 20px;
            white-space: nowrap;
        }

        .switch__container{
            margin: 0px;
        }
    }





`;

export const Next = styled.div`
    h2{
        font-size: 32px;
        font-weight: 500;
        color: #403F4C;
        margin: 0 0 0 81px;
    }

    .active {
        background-color: #004FFF;
        color: #fff;
        border: #004FFF;
    }


    .nextClass{
       h2{
            margin: 0;
            font-weight: 300;
            color: #004FFF;

            strong{
                font-weight: 500;
            }
        }


       .borderCancelled{
            border-left: 4px solid #FF5666;
            width: 1px;
            border-radius: 73px 0 0 72px;
            height: auto;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            margin: 15px -4px 0 0px;
            position: relative;
            z-index: 9999;
            background-color: #FF5666;
        }

       .boxClass{
           background-color: #FFF;
           padding: 15px;
           margin-top: 15px;
           border-radius: 10px;
           box-shadow: 0 0 10px rgba(0,0,0,.25);
        }

       h3{
           color: #403F4C;
           font-size: 15px;
           font-weight: bold;
           margin: 0 0 6px 0;
       }

       .rating-card {
           display: flex;
           align-content: center;
           align-items: center;
           flex-direction: column;

           .title{
                font-size: 12px;
                color: #000000 !important;
                font-weight: bold !important;
           }
           .average {
                color: #000000 !important;
                font-size: 18px;
                font-weight: bold !important;
           }
           .stars {
                span {
                        margin: 0 1px 0 0;
                        font-size: 22px;
                }
            }
            .startList{
                margin:0;
            }

       }

       .infos{
           display: flex;
           justify-content: space-between;
           align-items: center;
           flex-wrap: wrap;
           align-content: space-between;

           .classContent{
                width: 100%;
                gap: 15px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;

                .classAndTeacher{
                    display: flex;
                    margin: 1px 0 0 0;

                    h4{
                        margin: 0 10px 0 0;
                    }
                }
           }

           .status{
                display: flex;
                align-items: center;
                width: auto !important;

                .run{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .success {
                    color: #00D36A;
                }

                .pending {
                    color: #004FFF;
                }
                button {
                    padding: 0 !important;
                }

                button.active {
                    width: 84px;
                    height: 22px;
                    border-radius: 26px;
                    background: #004FFF;
                    border: 1px solid #004FFF;
                    color: #fff;
                    cursor: pointer;
                    font-size: 11px;
                    font-weight: bold;
                }

                button.update {
                    width: 84px;
                    height: 22px;
                    border-radius: 26px;
                    background: #00D36A;
                    border: 1px solid #00D36A;
                    color: #fff;
                    cursor: pointer;
                    font-size: 11px;
                    font-weight: bold;
                }

                i {
                    padding-left: 5px;
                }

               h4{
                   .fa{
                        margin-left: 5px;
                   }
               }

           }

           button{
            background-color: transparent;
            border: 1px solid #B2B2B7;
            border-radius: 26px;
            color: #87868F;
            font-size: 11px;
            width: 58px;
            height: 22px;
            float: right;
            cursor: pointer;
            padding-left: 8px;
               }

           h4{
                font-size: 14px;
                color: #5A6C96;
                font-weight: 500;
                margin: 6px 25px 0 0;
                display: flex;
                align-items: center;
           }


       }

       img{
           width: 18px;
           height: 12px;
           margin: 0 8px 0 0;
       }
   }

`;
